/**
 * <ry-pricing> + <ry-pricing-card>
 *
 * Pricing section with featured card variant.
 *
 * Usage:
 * <ry-pricing>
 *   <ry-pricing-card title="Pro" price="$29/mo" featured>
 *     <ul class="ry-check-list"><li>Feature 1</li></ul>
 *     <ry-button>Choose Pro</ry-button>
 *   </ry-pricing-card>
 * </ry-pricing>
 */

import { RyElement } from '../core/ry-element.js';

export class RyPricing extends RyElement {}

export class RyPricingCard extends RyElement {
  setup(): void {
    this.#transformMarkup();
  }

  #transformMarkup(): void {
    if (this.$('[data-ry-target="title"]')) return;

    const title = this.getAttribute('title') ?? '';
    const price = this.getAttribute('price') ?? '';
    const childrenHTML = this.innerHTML;

    this.innerHTML = `
      ${title ? `<h3 data-ry-target="title" class="ry-pricing-card__title">${title}</h3>` : ''}
      ${price ? `<div data-ry-target="price" class="ry-pricing-card__price">${price}</div>` : ''}
      ${childrenHTML}
    `;
  }
}

customElements.define('ry-pricing', RyPricing);
customElements.define('ry-pricing-card', RyPricingCard);
